import React from 'react'
import classnames from 'classnames'

import { Item } from '../../../core/items'
import { getTasteDisplayName } from '../../../core/i18n'
import { SupportedLanguageCode } from '../../../core/i18n'
import { strings } from './each-item-content'
import styles from '../../styles/modules/table.module.scss'

interface Props {
  item: Item
  activeLanguage: SupportedLanguageCode
}

const TastesTable: React.FC<Props> = props => {
  const { activeLanguage } = props

  return (
    <div
      className={classnames({
        [styles.wrapper]: true,
        [styles.stocker]: true,
      })}
    >
      <table className={`${styles.container} ${styles.tastesTable}`}>
        <tbody>
          {props.item.tastes.map((elem, index) => (
            <tr
              className={styles.rowStatic}
              key={`taste-${activeLanguage}-${index}`}
            >
              <td className={styles.cell} style={{ width: '70%' }}>
                {getTasteDisplayName(elem, activeLanguage) || strings.notSet}
              </td>
              <td className={styles.cell} style={{ width: '30%' }}>
                {elem.value}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default TastesTable
